<div class="container-more-less-wrapper">
  <div class="container-more-less" #teasers *ngIf="injected; else notInjected">
    <ng-content></ng-content>
  </div>
  <ng-template #notInjected>
    <div class="container-more-less container-more-less--row">
      <div *ngFor="let card of cards" [ngClass]="classes" #cardList>
        <ng-container *ngIf="moreLessType === MoreLessType.TEASER">
          <hdi-teaser
            [type]="card.type!"
            [imageSrc]="card.imageSrc"
            [badges]="card.badges!"
            [badgeSize]="card.badgeSize!"
            [headline]="card.headline!"
            [headlineSize]="card.headlineSize"
            [description]="card.description"
            [imageBorder]="card.imageBorder"
            [linkType]="card.linkType"
            [label]="card.label ?? '' | capitalize"
            [hrefType]="card.hrefType!"
            [href]="card.href ? card.href : ''"
            [video]="card.video"
          ></hdi-teaser>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <hdi-button
    *ngIf="teasersLength > initialVisibleTeasers"
    [type]="type"
    [label]="showMoreLessLabel | capitalize"
    [iconName]="iconSelected"
    (click)="showMoreLess()"
  ></hdi-button>
</div>
